/**
     *  Do not edit this file, it is auto-generated at build time!
     *  Note: component-generation is optional! See ./.gitignore for directions to remove it if not needed.
     */
    import type { Component } from "svelte";
    

    /** Components */
    import AboutHero from "@component/content/AboutHero.svelte";
    import BlogArticle from "@component/content/BlogArticle.svelte";
    import BlogGrid from "@component/content/BlogGrid.svelte";
    import CTASection from "@component/content/CTASection.svelte";
    import CompareTable from "@component/content/CompareTable.svelte";
    import ContactForm from "@component/content/ContactForm.svelte";
    import FAQ from "@component/content/FAQ.svelte";
    import HeroSection from "@component/content/HeroSection.svelte";
    import LeadCaptureForm from "@component/content/LeadCaptureForm.svelte";
    import LegalDocument from "@component/content/LegalDocument.svelte";
    import LegalSection from "@component/content/LegalSection.svelte";
    import LighthouseScores from "@component/content/LighthouseScores.svelte";
    import LogoCloud from "@component/content/LogoCloud.svelte";
    import NoGoIndustries from "@component/content/NoGoIndustries.svelte";
    import PortfolioGrid from "@component/content/PortfolioGrid.svelte";
    import ServiceDetail from "@component/content/ServiceDetail.svelte";
    import ServicesGrid from "@component/content/ServicesGrid.svelte";
    import StatsGrid from "@component/content/StatsGrid.svelte";
    import TeamGrid from "@component/content/TeamGrid.svelte";
    import TestimonialCard from "@component/content/TestimonialCard.svelte";
    import Timeline from "@component/content/Timeline.svelte";
    import ValuesGrid from "@component/content/ValuesGrid.svelte";
    import Logo from "@component/patterns/Logo.svelte";
    import SiteFooter from "@component/patterns/SiteFooter.svelte";
    import SiteHeader from "@component/patterns/SiteHeader.svelte";

    export const components: Record<string, Component<any>> = {
        AboutHero,
        BlogArticle,
        BlogGrid,
        CTASection,
        CompareTable,
        ContactForm,
        FAQ,
        HeroSection,
        LeadCaptureForm,
        LegalDocument,
        LegalSection,
        LighthouseScores,
        LogoCloud,
        NoGoIndustries,
        PortfolioGrid,
        ServiceDetail,
        ServicesGrid,
        StatsGrid,
        TeamGrid,
        TestimonialCard,
        Timeline,
        ValuesGrid,
        Logo,
        SiteFooter,
        SiteHeader,
    }
    
